// @flow
import { styled } from 'mz-ui-kit'
import * as linkAppearance from './appearance/link'
import * as generalAppearance from './appearance/general'
import * as outlinedAppearance from './appearance/outlined'
import * as flatAppearance from './appearance/flat'
import * as boldAppearance from './appearance/bold'
import { getAppearanceFunc } from '../../../utils'

// Constants
const BASE_CLASS = 'button'
const APPEARANCES = {
  bold: boldAppearance,
  general: generalAppearance,
  outlined: outlinedAppearance,
  flat: flatAppearance,
  link: linkAppearance,
}

const createAppearanceFunc = getAppearanceFunc(APPEARANCES, 'general')

export const StyledButton = styled(
  {
    base: 'button',
    mozClassName: ({ $appearance }) => [
      BASE_CLASS,
      `${BASE_CLASS}--${$appearance}`,
    ],
  },
  createAppearanceFunc('StyledButton')
)

export const ButtonText = styled(
  {
    base: 'span',
    mozClassName: `${BASE_CLASS}__text`,
  },
  createAppearanceFunc('ButtonText')
)

export const LoadingContainer = styled(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__loading`,
  },
  createAppearanceFunc('LoadingContainer')
)
